export default function onSetInfo(m, info) {
	m.setData({
		currentMeasurementInfo: {
			...m.data.currentMeasurementInfo,
			...info,
		},
	});
}
